import {Component, OnInit} from '@angular/core';
import {Localization} from '../../../common/enums/localization';

@Component({
  selector: 'app-intervention-teams-navigation',
  templateUrl: './intervention-teams-navigation.component.html',
  styleUrls: ['./intervention-teams-navigation.component.scss']
})
export class InterventionTeamsNavigationComponent implements OnInit {

  public readonly Localization = Localization;

  constructor() {
  }

  ngOnInit(): void {
  }
}
